<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer une nouvelle livraison</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="date_livraison"><strong>Date</strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="date" id="date_livraison" v-model="date_livraison"></b-form-input>
            <span class="field-error">{{ errors.date_livraison }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="titre"><strong>Titre : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="titre" v-model="titre" :class="{hasError: errors.titre !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.titre }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="numero_version"><strong>Numéro version : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="numero_version" v-model="numero_version" :class="{hasError: errors.numero_version !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.numero_version }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="contenu"><strong>Contenu : </strong></label>
            </b-col>
            <b-col sm="9">
              <ckeditor :editor="editor" v-model="contenu" :config="editorConfig"></ckeditor>
              <span class='field-error'>{{ errors.contenu }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="commentaire"><strong>Commentaire : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="commentaire" v-model="commentaire" :class="{hasError: errors.commentaire !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.commentaire }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3" style="margin-top:15px">
              <label for="is_active"><strong>Active</strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-checkbox id="is_active" v-model="is_active" name="check-button" switch class="col-md-12 mt-3"></b-form-checkbox>
            </b-col>
          </b-row>

          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"/> Liste des livraisons
            </b-button>
            <b-button type="button" @click="saveLivraison" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"/> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  export default {
    name: "Add",
    data() {
      return {
        titre: "",
        numero_version: "",
        contenu: "",
        commentaire: "",
        date_livraison: "",
        is_active: false,
        editor: ClassicEditor,
        editorConfig: {
          allowedContent: true,
          toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'],
          language: 'fr'
        },
        errors: {
          titre: "",
          numero_version: "",
          contenu: "",
          commentaire: "",
          date_livraison: ""
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      saveLivraison() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let self = this;
          let dataPost = {};
          dataPost.titre = this.titre;
          dataPost.numero_version = this.numero_version;
          dataPost.contenu = this.contenu;
          dataPost.commentaire = this.commentaire;
          dataPost.date_livraison = this.date_livraison;
          dataPost.is_active = this.is_active;
          this.$axios
            .post("/administration/livraisons/store", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "La livraison a été bien créée",
                showConfirmButton: false,
                timer: 3700
              });
              this.clearFields();
              setTimeout(() => this.returnBack(), 3800);
              this.returnBack()
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: error,
                showConfirmButton: false,
                timer: 4000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/administration/livraisons/list"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (this.titre === "") {
          this.errors.titre = "Le titre est obligatoire";
          valid = false;
        }
        if (this.numero_version === "") {
          this.errors.numero_version = "Le numero de version est obligatoire";
          valid = false;
        }
        if (this.contenu === "") {
          this.errors.contenu = "Le contenu est obligatoire";
          valid = false;
        }
        if (this.date_livraison === "") {
          this.errors.date_livraison = "La date de livraison est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.titre = "";
        this.errors.numero_version = "";
        this.errors.contenu = ""
        this.errors.date_livraison = ""
      },
      clearFields() {
        this.titre = '';
        this.numero_version = '';
        this.contenu = '';
        this.commentaire = '';
        this.date_livraison = '';
      },
    }
  }
</script>
